import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconLayersComponent } from "./med-icon-layers.component";

@NgModule({
  declarations: [
    MedIconLayersComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconLayersComponent,
  ],
})
export class MedIconLayersModule { }
